// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  border-radius: 0.475rem;
  border: none;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.modal-header {
  border-bottom: 1px solid #e4e6ef;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-header .modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #181c32;
  margin: 0;
}
.modal-header .btn-icon {
  cursor: pointer;
}
.modal-header .btn-icon span {
  color: #5e6278;
  font-size: 1.5rem;
  line-height: 1;
}
.modal-header .btn-icon span:hover {
  color: #181c32;
}

.modal-body {
  padding: 1.5rem;
}
.modal-body .form-check {
  margin-top: 1.5rem;
  padding-left: 0;
}
.modal-body .form-check .form-check-input {
  cursor: pointer;
  margin-top: 0.25rem;
}
.modal-body .form-check .form-check-label {
  color: #5e6278;
  font-size: 0.95rem;
  cursor: pointer;
  margin-right: 0.5rem;
}

.modal-footer {
  border-top: 1px solid #e4e6ef;
  padding: 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
.modal-footer .btn {
  min-width: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/branch-selection-modal/branch-selection-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,YAAA;EACA,uCAAA;AACF;;AAEA;EACE,gCAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;AACE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAEI;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AAAN;AAEM;EACE,cAAA;AAAR;;AAMA;EACE,eAAA;AAHF;AAKE;EACE,kBAAA;EACA,eAAA;AAHJ;AAKI;EACE,eAAA;EACA,mBAAA;AAHN;AAMI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAJN;;AASA;EACE,6BAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;AANF;AAQE;EACE,gBAAA;AANJ","sourcesContent":[".modal-content {\n  border-radius: 0.475rem;\n  border: none;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  border-bottom: 1px solid #e4e6ef;\n  padding: 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n  .modal-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #181c32;\n    margin: 0;\n  }\n  \n  .btn-icon {\n    cursor: pointer;\n    \n    span {\n      color: #5e6278;\n      font-size: 1.5rem;\n      line-height: 1;\n      \n      &:hover {\n        color: #181c32;\n      }\n    }\n  }\n}\n\n.modal-body {\n  padding: 1.5rem;\n  \n  .form-check {\n    margin-top: 1.5rem;\n    padding-left: 0;\n    \n    .form-check-input {\n      cursor: pointer;\n      margin-top: 0.25rem;\n    }\n    \n    .form-check-label {\n      color: #5e6278;\n      font-size: 0.95rem;\n      cursor: pointer;\n      margin-right: 0.5rem;\n    }\n  }\n}\n\n.modal-footer {\n  border-top: 1px solid #e4e6ef;\n  padding: 1.5rem;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  \n  .btn {\n    min-width: 100px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
